import Link from "next/link";
import pages from "pages/_router";
import React from "react";
import { MonthPlanSimpleWeekDto } from "shared/api";
import { formatDate, UseModalProps } from "shared/lib";
import { Entity, Modal } from "shared/ui";

import styles from "./choose-fp-modal.module.scss";

export interface IChooseFpModal extends UseModalProps {
  route: ReturnType<ReturnType<typeof pages.company>["finances"]["yearMonth"]>;
  data: MonthPlanSimpleWeekDto;
}

export const ChooseFpModal = (props: IChooseFpModal) => {
  return (
    <Modal onClose={props.close} width={450}>
      <Modal.Header>
        <Modal.Title>
          Финансовые планирования{" "}
          <div>
            за&nbsp;
            {formatDate(props.data.from, {
              year: undefined,
              month: undefined,
            })}
            —{formatDate(props.data.to, { year: undefined })}
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {props.data.financialPlans.map((it) => (
          <Entity key={it.id} hover>
            <Entity.Field
              title={
                <Link href={props.route.results.id(it.id).href} className={styles.link}>
                  {formatDate(it.from)} — {formatDate(it.to)}
                  {it.status === "DRAFT" && ", черновик"}
                  {it.status === "ON_APPROVAL" && ", на утверждении"}
                </Link>
              }
            />
            <Entity.Field description={<>Создано {formatDate(it.createdAt)}</>} right />
          </Entity>
        ))}
      </Modal.Body>

      <Modal.Actions>
        <Modal.Action onClick={props.close}>Закрыть</Modal.Action>
      </Modal.Actions>
    </Modal>
  );
};

ChooseFpModal.defaultProps = {};
